<img class="dgh-print-paper__label__icon" [src]="image.qrCode" (load)="imageLoaded()" />
<div class="dgh-print-paper__label__content" [class.dgh-print-paper__label__content_packaging-unit]="image.record.getRecordType() === RecordType.PackagingUnit">
  @if (canShowMoreInfo) {
    <div class="dgh-print-paper__label__content__element">{{ 'overrides.RecordType.' + image.record.getRecordType() | translate }}</div>
  }
  @if (canShowMoreInfo) {
    <div class="dgh-print-paper__label__content__element">{{ image.record.getRecordId() | getShortRecordId }}</div>
  }
  <div class="dgh-print-paper__label__content__element">{{ title }}</div>
  @if (image?.index > 0) {
    <div class="dgh-print-paper__label__content__element">{{ 'label-print.fields.part' | translate:{ part: image.index } }}</div>
  }
  @if (!!image?.record.getField(DottedKey.LegacyPackagingUnitId)) {
    <div class="dgh-print-paper__label__content__element">
      {{ image.record.getField(DottedKey.LegacyPackagingUnitId) }}
    </div>
  }
  @if (!!image?.record.getField(DottedKey.LegacyLocationRange)) {
    <div class="dgh-print-paper__label__content__element">
      {{ image.record.getField(DottedKey.LegacyLocationRange) }}
    </div>
  }
  @if (showOrganisationName) {
    <div class="dgh-print-paper__label__content__element">
      {{ organisationName }}
    </div>
  }
  @if (!!image?.record.getField(DottedKey.DavExpiryExpectedDate)) {
    <div class="dgh-print-paper__label__content__element">
      {{ expiryDate | readableDate }}
    </div>
  }
</div>
